export enum EAccountSupplierFields {
  FullName = 'fullName',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  CompanyName = 'companyName',
  EstablishmentDate = 'establishmentDate',
  Website = 'website',
  ProductSources = 'productSources',
  ManufactureCountries = 'manufactureCountries',
  SkuAmount = 'skuAmount',
  SellingCountries = 'sellingCountries',
  WarehouseAddress = 'warehouseAddress',
  VatNumber = 'vat_number',
}

export enum EPoliciesFields {
  Discount = 'discount',
  HasDiscount = 'hasDiscount',
  MapPercent = 'mapPercent',
  IsMapPercent = 'isMapPercent',
  RestrictedMarketplaceIds = 'restrictedMarketplaceIds',
  ShipFromCountryIds = 'shipFromCountryIds',
  ProcessingTimeId = 'processingTimeId',
  ShippingDetails = 'shippingDetails',
  Shipping = 'shipping',
  IsReturnApprove = 'isReturnApprove',
  PaysForShippingId = 'paysForShippingId',
  ReturnWindowTimeId = 'returnWindowTimeId',
  ReturnsDescription = 'returnsDescription',
}

export enum EStoreFields {
  Name = 'name',
  Description = 'description',
  Category = 'category',
  CategoryName = 'categoryName',
}

export enum EPaymentsFields {
  CountryId = 'countryId',
  MainAddress = 'mainAddress',
  AdditionalAddress = 'additionalAddress',
  City = 'city',
  Zipcode = 'zipcode',
  SwiftBic = 'swiftBic',
  Iban = 'iban',
  RoutingNumber = 'routingNumber',
  AccountHolderName = 'accountHolderName',
  AccountNumber = 'accountNumber',
  AccountType = 'accountType',
}
